import makeStyles from "@mui/styles/makeStyles";
import { SURVEY_COLORS } from "../../../shared/theme-constants";
import { getSharedStyles } from "../../../shared/shared-styles";

export const useStyles = makeStyles((theme) => ({
  "@global": {
    ".k-popup": {
      zIndex: "99999 !important",
    },
    ".k-popup.k-popup-transparent": {
      zIndex: "99999 !important",
    },
    ".k-calendar": {
      zIndex: "99999 !important",
    },
    ".k-animation-container": {
      zIndex: "99999 !important",
    },
    "@media (max-width: 600px)": {
      ".k-animation-container:has(.k-calendar)": {
        left: "auto !important",
        right: "16px !important",
        maxWidth: "calc(100vw - 32px) !important",
        boxSizing: "border-box",
      },
      ".k-animation-container:has(.k-calendar) .k-calendar": {
        maxWidth: "100%",
        boxSizing: "border-box",
      },
    },
  },
  ...getSharedStyles(theme),
  // Overrides the shared fieldsContainer (margins only) to also restore the two-column date-field layout
  fieldsContainer: {
    marginBottom: "40px",
    marginTop: "50px",
    "& > div:has(.commissioning-date-field)": {
      display: "inline-block",
      verticalAlign: "top",
      width: "calc(50% - 8px)",
    },
    "& > div:has(.commissioning-date-field) + div:has(.commissioning-date-field)": {
      marginLeft: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      "& > div:has(.commissioning-date-field)": {
        display: "block !important",
        width: "100% !important",
        marginLeft: "0 !important",
        boxSizing: "border-box",
      },
      "& > div:has(.commissioning-date-field) + div:has(.commissioning-date-field)": {
        marginLeft: "0 !important",
      },
    },
  },
}));
